import React from "react";
import { Infout } from "./Infout";
import { Infoin } from "./Infoin";

import "./infoview.css";
export function Infoview(){
  return (
    <div className="container-info-body" lang="es" style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
      <Infout />
      <Infoin />
    </div>
  );
}
